import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getCustomObjects = createAsyncThunk(
  'getCustomObjects',
  async (object, { rejectWithValue }) => {
    const {
      type, view, accountId,
    } = object;

    const query = {
      page: type === 'all' ? 'dashboard' : 'account',
      accountId,
      ...(view && { view }),
    };

    const finalQuery = buildSalesforceParamsQuery(query, object);
    const response = await request('/custom-object', { method: 'GET', query: finalQuery });
    if (response.success) return response.data;
    const error = response.error && response.error.message ? response.error.message : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getCustomObjectPinningData = createAsyncThunk(
  'getCustomObjectPinningData',
  async (object, { rejectWithValue }) => {
    const finalQuery = buildSalesforceParamsQuery({}, object);
    const response = await request('/custom-object-pinning-data', { method: 'GET', query: finalQuery });
    if (response.success) return response.data;
    const error = response.error && response.error.message ? response.error.message : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const customObjectPinningAction = createAsyncThunk('customObjectPinningAction', async (object, { rejectWithValue }) => {
  const response = await request('/custom-object-pinning-action', { method: 'POST', body: { pinningData: object.pinningData } });
  if (response.success) return response.data;
  const error = response.error && response.error.message ? response.error.message : response.error;
  throw rejectWithValue(error || 'Something went wrong');
});
